import React from "react";
import { InfoContentPage as PageType } from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  onNext: () => void;
}

const InfoContentPage: React.FC<Props> = ({ page, onNext }) => {
  return (
    <div className="page page--info-content">
      <div className="page__container">
        <h2 className="page__question">{page.title}</h2>

        {page.description && (
          <p className="page__subtitle">{page.description}</p>
        )}

        {page.bullets && (
          <ul className="page__bullets">
            {page.bullets.map((bullet, index) => (
              <li key={index}>{bullet}</li>
            ))}
          </ul>
        )}

        {page.experts && (
          <div className="experts-grid">
            {page.experts.map((expert, index) => (
              <div key={index} className="expert-card">
                <img
                  src={expert.image}
                  alt={expert.name}
                  className="expert-card__image"
                />
                <h3 className="expert-card__name">{expert.name}</h3>
                <p className="expert-card__title">{expert.title}</p>
              </div>
            ))}
          </div>
        )}

        <div className="page__actions">
            <button className="page__button page__button--block" onClick={onNext}>
              {page.buttonText}
            </button>
        </div>
      </div>
    </div>
  );
};

export default InfoContentPage;
